import { notify } from "@kyvg/vue3-notification";

function normalizeText(value) {
    if (Array.isArray(value)) return value.join(". ");
    if (typeof value === "object" && value !== null) return JSON.stringify(value);
    return String(value ?? "");
}

export default {
    install(app) {
        app.config.globalProperties.$notifyError = (data, ...args) => {
            if (data?.response?.data?.result === false) {
                data = data.response.data;
            }
            const rawText = data?.message ?? data?.errors ?? data?.error;
            const details = data?.details;
            const title = data?.title ?? "Ошибка";

            let options = Object.assign(
                {
                    duration: 7000,
                    type: "error",
                    speed: 1000,
                    title: title,
                    text: normalizeText(rawText),
                    data: {}
                },
                ...args
            );
            if (details) {
                options.data.details = details
            }

            notify(options);
        };

        app.config.globalProperties.$notifySuccess = (data, ...args) => {
            const rawText = data?.message ?? data?.success ?? data;
            const details = data?.details;
            const title = data?.title ?? "Успех";

            let options = Object.assign(
                {
                    duration: 7000,
                    type: "success",
                    speed: 1000,
                    title: title,
                    text: normalizeText(rawText),
                    data: {}
                },
                ...args
            );

            if (details) {
                options.data.details = details;
            }

            notify(options);
        };

        app.config.globalProperties.$notifyWarning = (data, ...args) => {
            const rawText = data?.message ?? data?.warning ?? data;
            const details = data?.details;
            const title = data?.title ?? "Предупреждение";
            
            let options = Object.assign(
                {
                    duration: 7000,
                    type: "warn",
                    speed: 1000,
                    title: title,
                    text: normalizeText(rawText),
                    data: {}
                },
                ...args
            );

            if (details) {
                options.data.details = details;
            }

            notify(options);
        };
    }
};